import { SET_SELECTED_SCHEDULE } from "redux/constants/flowDesigner";
import {
  SET_IS_TITLEBAR_TRIGGER_LIST_OPEN,
  SET_IS_TITLEBAR_EXECUTE_TRIGGER_LIST_OPEN,
  SET_EXECUTE_SELECTED_TRIGGER_ID,
  SHOW_TRIGGER_PROPERTIES_PANEL,
  HIDE_TRIGGER_PROPERTIES_PANEL,
  SET_SELECTED_TRIGGER,
  CLEAR_SELECTED_TRIGGER,
  SET_FLOW_TRIGGERS,
  CLEAR_FLOW_TRIGGERS,
  ADD_FLOW_TRIGGER,
  DELETE_FLOW_TRIGGER,
  UPDATE_FLOW_TRIGGER,
  OPEN_TRIGGER_DELETE_DIALOG,
  CLOSE_TRIGGER_DELETE_DIALOG,
  SET_TRIGGER_FOR_DELETE,
  CLEAR_TRIGGER_FOR_DELETE,
  START_DRAG_TRIGGER,
  STOP_DRAG_TRIGGER,
  TOGGLE_TRIGGER,
} from "redux/constants/flowDesigner";


export const setIsTitlebarTriggerListOpen = (payload) => ({
  type: SET_IS_TITLEBAR_TRIGGER_LIST_OPEN,
  payload,
});
export const setIsTitlebarExecuteTriggerListOpen = (payload) => ({
  type: SET_IS_TITLEBAR_EXECUTE_TRIGGER_LIST_OPEN,
  payload,
});
export const setExecuteSelectedTriggerId = (payload) => ({
  type: SET_EXECUTE_SELECTED_TRIGGER_ID,
  payload,
});
export const openTriggerPropertiesPanel = () => ({
  type: SHOW_TRIGGER_PROPERTIES_PANEL,
});
export const closeTriggerPropertiesPanel = () => ({
  type: HIDE_TRIGGER_PROPERTIES_PANEL,
});
export const setSelectedTrigger = (payload) => ({
  type: SET_SELECTED_TRIGGER,
  payload,
});
export const clearSelectedTrigger = () => ({
  type: CLEAR_SELECTED_TRIGGER,
});
export const setFlowTriggers = (payload) => ({
  type: SET_FLOW_TRIGGERS,
  payload,
});
export const clearFlowTriggers = () => ({
  type: CLEAR_FLOW_TRIGGERS,
});
export const addFlowTrigger = (payload) => ({
  type: ADD_FLOW_TRIGGER,
  payload,
});
export const deleteFlowTrigger = () => ({
  type: DELETE_FLOW_TRIGGER,
});
export const updateFlowTrigger = (payload) => ({
  type: UPDATE_FLOW_TRIGGER,
  payload,
});
export const setTriggerForDelete = (payload) => ({
  type: SET_TRIGGER_FOR_DELETE,
  payload,
});
export const clearTriggerForDelete = () => ({
  type: CLEAR_TRIGGER_FOR_DELETE,
});
export const openTriggerDeleteDialog = () => ({
  type: OPEN_TRIGGER_DELETE_DIALOG,
});
export const closeTriggerDeleteDialog = () => ({
  type: CLOSE_TRIGGER_DELETE_DIALOG,
});
export const startDragTrigger = () => ({
  type: START_DRAG_TRIGGER,
});
export const stopDragTrigger = () => ({
  type: STOP_DRAG_TRIGGER,
});
export const toggleTrigger = (payload) => ({
  type: TOGGLE_TRIGGER,
  payload,
});
export const setSelectedSchedule = (payload) => ({
  type: SET_SELECTED_SCHEDULE,
  payload,
});
